import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ListPatientsPendingInvoice from './components/ListPatientsPendingInvoice';

const PatientsPendingInvoice = (props) => {
    return (<Container >
        <Row>
            <Col md={12}>
                <h3 className="page-title">Estado de Facturación en los Pacientes</h3>
            </Col>
        </Row>
        <ListPatientsPendingInvoice props={props} />
    </Container>)
};

export default PatientsPendingInvoice;